import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * Settings -- `/settings`. Page body lazy-loaded.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/settings",
	component: lazyRouteComponent(() => import("./index.page")),
})
